import React from 'react';
import { StepLabel as MuiStepLabel, } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
export const StepLabel = ({ _sx, className = '', optional, icon, error = false, children, componentsProps = {}, StepIconComponent, StepIconProps, pending = false, dataTestId, }) => {
    const iconComponent = pending ? React.createElement(ErrorIcon, { className: "Mui-pending" }) : icon;
    return (React.createElement(MuiStepLabel, { sx: _sx, className: className, icon: iconComponent, error: error, optional: optional, componentsProps: componentsProps, StepIconComponent: StepIconComponent, StepIconProps: StepIconProps, "data-testid": dataTestId }, children));
};
